import React, { useState } from 'react';
import ReactApexChart from 'react-apexcharts';
import "./css/piechart.css"

const Piechart = () => {
  const [state, setState] = useState({
    series: [44, 55, 13, 43, 22],
    options: {
      chart: {
        width: '100%',
        type: 'pie',
        background: {
          gradient: {
            type: 'linear', // Type of gradient (linear or radial)
            shadeIntensity: 0.5, // Intensity of the gradient shade
            gradientToColors: ['#ff7f50', '#6a5acd'], // Gradient colors
            opacityFrom: 1, // Starting opacity
            opacityTo: 0.5, // Ending opacity
            stops: [0, 100], // Gradient stop points
          },
        },
      },
      labels: ['Team A', 'Team B', 'Team C', 'Team D', 'Team E'],
      legend: {
        position: 'bottom',
        horizontalAlign: 'center',
        labels: {
          colors: ['#fff'], // Change legend text color (use hex, rgb, or color name)
        },
      },
      dataLabels: {
        enabled: true,
        style: {
          fontSize: '14px',
          colors: ['#fff'], // Custom label color
        },
        dropShadow: {
          enabled: false,
        },
        offsetY: 10,
      },
      plotOptions: {
        pie: {
          dataLabels: {
            offset: 0,
            minAngleToShowLabel: 10,
          },
        },
      },
      responsive: [
        {
          breakpoint: 480,
          options: {
            chart: {
              width: 200,
            },
            legend: {
              position: 'bottom',
              horizontalAlign: 'center',
              labels: {
                colors: ['#fff'], // Change color for smaller screens
              },
            },
          },
        },
      ],
    },
  });

  return (
    <div>
      <div id="chart">
        <ReactApexChart options={state.options} series={state.series} type="pie" width={`100%`} />
      </div>
      <div id="html-dist"></div>
    </div>
  );
};

export default Piechart;
